import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { DaysPassedPipe } from './days-passed.pipe';

@NgModule({
  declarations: [DaysPassedPipe],
  imports: [CommonModule],
  exports: [DaysPassedPipe],
  providers: [DatePipe, DaysPassedPipe]
})
export class DaysPassedPipeModule {}
